<app-modal-template
  [title]="dialogInputData.title"
  [size]="pencilModalSizeEnum.SMALL"
  [hasCloseButton]="false"
  class="speedbump-modal-template"
>
  <div class="speedbump-content" content-description>
    <div class="body">
      <div class="body-main">
        {{ (_bodyMain$ | async) }}
      </div>
    </div>
  </div>

  <div content-actions>
    <app-pencil-button
      *ngFor="let control of dialogInputData.controls"
      [theme]="'primary'"
      (clickEvent)="close(true)"
      [icon]="control.icon"
      [label]="control.text"
      [iconConfig]="{ type: control.isSvg ? IconTypes.svgIcon : IconTypes.matIcon }"
    >
    </app-pencil-button>
  </div>
</app-modal-template>
